import { SET_TOKEN, CLEAR_TOKEN } from '../actions/token.js';
import { ADD_MESSAGE, DISMISS_MESSAGE, CLEAN_MESSAGES } from '../actions/messages.js';
import { SET_OUTBOUND_MESSAGE } from '../actions/outboundMessages.js';

const initialState = {
  token: null,
  user: null,
  messages: [],
  outboundMessages: {},
};

/**
 * Handle actions on state.
 */
export default function AdvisoryApp(state = initialState, action) {
  switch (action.type) {
    // Set token.
    case SET_TOKEN:
      return Object.assign({}, state, {
        token: action.token,
        user: action.user,
      });

    // And clear token.
    case CLEAR_TOKEN:
      return Object.assign({}, state, {
        token: null,
      });

    // Add message adds a message at the end of array.
    case ADD_MESSAGE:
      return Object.assign({}, state, {
        messages: [
          ...state.messages,
          {
            message: action.message,
            severity: action.severity,
            addedTime: Date.now(),
          },
        ]
      })

    // Dismiss message removes a specific message from the array.
    case DISMISS_MESSAGE:
      return Object.assign({}, state, {
        messages: [
          ...state.messages.slice(0, action.id),
          ...state.messages.slice(action.id + 1)
        ]
      })

    // Clean messages removes all messages that are older than 5 seconds.
    case CLEAN_MESSAGES:
      return Object.assign({}, state, {
        messages: ((state, action) => {
          var ms = [];
          state.messages.forEach((message) => {
            if ((message.addedTime + 5000) > Date.now()) {
              ms.push(message);
            }
          });

          return ms;
        })(state, action)
      })


    // Set an outbound message in the redux state.
    case SET_OUTBOUND_MESSAGE:
      var add = {};
      add[action.conversationId] = action.message;
      return Object.assign({}, state, {
        outboundMessages: Object.assign({}, state.outboundMessages, add),
      });

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AdvisoryApp.js